import { render, staticRenderFns } from "./BaseArticleDepartmentRow.vue?vue&type=template&id=4a0a3ae6&"
import script from "./BaseArticleDepartmentRow.vue?vue&type=script&lang=js&"
export * from "./BaseArticleDepartmentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports